var _path, _path2, _linearGradient, _path3, _path4, _rect, _linearGradient2, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Framing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#b9360c",
    d: "M22.277,21.4L12.824,7.733H36.8c0.349,0,0.672,0.182,0.854,0.48l7.111,11.667 c0.406,0.666-0.073,1.52-0.854,1.52H22.277z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#d43a02",
    d: "M4.456,19.831l8.368-12.098L22.277,21.4H5.278C4.472,21.4,3.997,20.494,4.456,19.831z"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "t8B_TUT6B8iG2Ix2yzGcea",
    x1: 17.612,
    x2: 40.08,
    y1: 10.216,
    y2: 40.599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fafafb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c8cdd1"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#t8B_TUT6B8iG2Ix2yzGcea)",
    d: "M44,24.133H25.956c-0.552,0-1,0.448-1,1v17.133c0,0.552,0.448,1,1,1H44c0.552,0,1-0.448,1-1 V25.133C45,24.581,44.552,24.133,44,24.133z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#199be2",
    d: "M39.033,30.511h-8.111c-0.276,0-0.5,0.224-0.5,0.5V37.3c0,0.276,0.224,0.5,0.5,0.5h8.111 c0.276,0,0.5-0.224,0.5-0.5v-6.289C39.533,30.735,39.309,30.511,39.033,30.511z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 3.644,
    height: 9.111,
    x: 11.289,
    y: 32.333
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "t8B_TUT6B8iG2Ix2yzGceb",
    x1: 3.2,
    x2: 18.902,
    y1: 17.504,
    y2: 43.164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fafafb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c8cdd1"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#t8B_TUT6B8iG2Ix2yzGceb)",
    d: "M21.222,24.133H5c-0.55,0-1,0.45-1,1v17.133c0,0.55,0.45,1,1,1h16.222c0.55,0,1-0.45,1-1 V25.133C22.222,24.583,21.772,24.133,21.222,24.133z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#d35230",
    d: "M16.745,43.267H9.787V32.574c0-0.552,0.448-1,1-1h4.957c0.552,0,1,0.448,1,1V43.267z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Framing);
export default __webpack_public_path__ + "static/media/icons8-framing.7929f4b71e9f007acc8162dc22afc31b.svg";
export { ForwardRef as ReactComponent };